import axios from 'axios'

export class AllauthError extends Error {
  constructor(errors, originalError = null) {
    super(originalError?.message);
    this.fieldBasedErrors = errors;
    this.originalError = originalError;
  }
}

export async function makeAllauthRequestAndParseErrors(request = {}) {
  try {
    return await axios.request({
      ...request,
      excludeTenantSlug: true,
      headers: { ...request.headers, 'X-CSRFToken': getCsrfTokenFromCookie() },
      // A status of 401 from an allauth endpoint just means that the session is not authenticated,
      // not necessarily an error with this particular request. If it's expected that this request would log a user
      // in, it's up to the caller of this function to check the response.
      // See https://docs.allauth.org/en/latest/headless/openapi-specification/#section/Authentication-Flows
      validateStatus: status => (status >= 200 && status < 300) || status === 401,
    })
  } catch (error) {
    if (error?.response?.data?.errors) {
      throw new AllauthError(allauthToDRFErrorFormat(error.response.data.errors), error);
    } else {
      throw new AllauthError({ non_field_errors: [error.message] }, error);
    }
  }
}

// This assumes the CSRF token cookie has already been set, normally by using a backend allauth browser API endpoint.
export function getCsrfTokenFromCookie() {
  const cookieName = "api_csrftoken"
  let cookieValue = null
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';')
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim()
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, cookieName.length + 1) === (cookieName + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(cookieName.length + 1))
        break
      }
    }
  }
  return cookieValue
}

export function allauthToDRFErrorFormat(errors) {
  // Errors from allauth are in a format like {errors: [{message: "Incorrect password.", param: "password"}]}.
  // Our regular backend API errors from Django REST Framework are in a format like {password: ['Incorrect password.']}
  // This function converts allauth errors to the DRF format with object keys as fields/params.
  const output = {};

  errors.forEach(error => {
    const param = error.param || 'non_field_errors';
    if (!output[param]) {
      output[param] = [];
    }
    output[param].push(error.message);
  });

  return output
}
